<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
            <el-form-item label="站点名称">
                <el-input v-model="formInline.siteName" placeholder="站点名称" style="width:220px"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="success" @click="queryList">查询</el-button>
                <el-button type="success" @click="addData">新增</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="getDataList" stripe border center :size="GCONFIG.styleTableSize" v-show="!showDialog"  v-loading="loading">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="siteId" label="站点Id" width="100"></el-table-column>
            <el-table-column prop="siteName" label="站点名称" width="120"></el-table-column>
            <el-table-column prop="consigneeName" label="联系人" width="110"></el-table-column>
            <el-table-column prop="consigneePhone" label="电话" width="110"></el-table-column>
            <el-table-column prop="beginTime" label="开放起始日期" width="110"></el-table-column>
            <el-table-column prop="endTime" label="开放结束日期" width="110"></el-table-column>
            <el-table-column prop="openTime" label="开放时间" width="110"></el-table-column>
            <el-table-column prop="maxNum" label="每天限制最大预约人数" width="110"></el-table-column>

            <el-table-column prop="provinceName" label="省份" width=""></el-table-column>
            <el-table-column prop="cityName" label="城市" width=""></el-table-column>
            <el-table-column prop="areaName" label="所在区" width=""></el-table-column>
            <el-table-column prop="address" label="地址" width=""></el-table-column>
            <el-table-column label="状态" width="60">
                <template slot-scope="scope">
                    <el-tag size="mini" v-if="scope.row.status==0" effect="plain">禁用</el-tag>
                    <el-tag size="mini" v-if="scope.row.status==1" type="success" effect="plain">有效</el-tag>
                </template>
            </el-table-column>

            <el-table-column label="操作" fixed="right" width="290">
                <template slot-scope="scope">
                    <el-button type="warning" size="mini" @click="handleUpdate(scope.row)">修改</el-button>
                    <el-button type="warning" size="mini" @click="handleDelete(scope.row)">删除</el-button>
                    <el-button type="success" size="mini" @click="handlePic(scope.row)">上传图片</el-button>

                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap" v-show="!showDialog">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>

        <!-- 新增批次window -->
        <el-dialog title="新增" :visible.sync="dialogFormVisible" center  center top="5vh">
            <el-form :model="form" label-width="120px" size="small ">
                <el-form-item label="站点名称" :required="true">
                    <el-input v-model="form.siteName" placeholder="站点名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="联系人" :required="true">
                    <el-input v-model="form.consigneeName" placeholder="联系人" clearable ></el-input>
                </el-form-item>
                <el-form-item label="电话" :required="true">
                    <el-input v-model="form.consigneePhone" type="number"  placeholder="电话" maxlength="11" clearable ></el-input>
                </el-form-item>
                <el-form-item label="开放起始日期" :required="true">
                    <el-date-picker
                            v-model=form.beginTime
                            type="date"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="开放结束日期" :required="true">
                    <el-date-picker
                            v-model=form.endTime
                            type="date"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="开放时间" :required="true">
                    <el-input v-model="form.openTime" placeholder="开放时间" clearable ></el-input>
                </el-form-item>
                <el-form-item label="每天限制最大预约人数" :required="true">
                    <el-input v-model="form.maxNum" type="number"  placeholder="每天限制最大预约人数" maxlength="9" clearable ></el-input>
                </el-form-item>

                <el-form-item label="省市区" :required="true">
                    <el-cascader
                            size="large"
                            :options="options"
                            v-model="selectedOptions"
                            @change="addressChange">
                    </el-cascader>
                </el-form-item>
                <el-form-item label="地址" :required="true">
                    <el-input placeholder="地址" v-model="form.address"></el-input>
                </el-form-item>
                <el-form-item label="经度" >
                    <el-input placeholder="经度" type="number" v-model="form.longitude"></el-input>
                </el-form-item>
                <el-form-item label="纬度" >
                    <el-input placeholder="纬度" type="number" v-model="form.latitude"></el-input>
                </el-form-item>
                <el-form-item label="状态" :required="true">
                    <el-select v-model="form.status"  placeholder="状态" :required="true">
                        <el-option
                                v-for="item in status"
                                :key="item.key"
                                :label="item.value"
                                :value="item.key">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input type="textarea" :rows="2" placeholder="备注" v-model="form.remark"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateOrAddData(form)">确 定</el-button>
            </div>
        </el-dialog>


    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {saveReunionSite,getReunionSiteEntity,getReunionSiteList,deleteReunionSite,getProvinceCityMap} from '@/api/api';
    import { CodeToText ,TextToCode} from 'element-china-area-data'
    export default {
        data() {
            return {
                showDialog: false,
                dialogFormVisible: false,
                dialogFormVisible1: false,
                getDataList: [],// 批次信息

                loading: true,
                form: {
                    siteId:null,
                    siteName: '',
                    consigneeName: '',
                    consigneePhone: '',
                    beginTime: null,
                    endTime: null,
                    openTime:'',
                    address:'',
                    longitude:null,
                    latitude:null,
                    status:1,
                    remark:'',
                    provinceName:'',
                    cityName:'',
                    areaName:'',
                    provinceCode:'',
                    cityCode:'',
                    areaCode:'',
                    maxNum:null,
                },
                formInline: {
                    siteName:'',
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0
                },

                options: [],
                regionData:[],
                selectedOptions: [],
                status:[{
                    key:1,
                    value:"可用"
                },{
                    key:0,
                    value:"禁用"
                }],
            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.queryDataList();
            this.getProvinceCityMap();
            //console.log(this.options)
        },
        methods: {
            addressChange(arr) {
                // this.form.provinceName=CodeToText[arr[0]];
                // this.form.cityName=CodeToText[arr[1]];
                // this.form.areaName=CodeToText[arr[2]];
                this.form.provinceCode=arr[0];
                this.form.cityCode=arr[1];
                this.form.areaCode=arr[2];
                //this.selectedOptions=[this.form.provinceCode,this.form.cityCode,this.form.areaCode];
                console.log(arr);
                //console.log(CodeToText[arr[0]], CodeToText[arr[1]], CodeToText[arr[2]]);
            },
            getProvinceCityMap(){
                this.loading = true;
                getProvinceCityMap().then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {

                        this.options = res.data.value;
                        this.regionData=res.data.value;
                        //console.log(this.options)
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            queryDataList(){
                this.loading = true;
                getReunionSiteList(this.formInline).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.formInline.recordsTotal = res.data.value.total;
                        this.getDataList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            //查询
            queryList(){
                this.queryDataList();
                this.formInline.currentPage = 1
            },

            returnHistory(){
                window.history.back()
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.queryDataList();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.queryDataList();
            },

            //新增事件
            addData() {
                this.form = {
                    siteId:null,
                    siteName: '',
                    consigneeName: '',
                    consigneePhone: '',
                    beginTime: null,
                    endTime: null,
                    openTime:'',
                    address:'',
                    longitude:null,
                    latitude:null,
                    status:1,
                    remark:'',
                    provinceName:'',
                    cityName:'',
                    areaName:'',
                    provinceCode:'',
                    cityCode:'',
                    areaCode:'',
                    maxNum:null,
                }
                this.selectedOptions=[];
                this.dialogFormVisible = true;
            },

            //修改事件
            handleUpdate(row) {
                this.form = {
                    siteId:row.siteId,
                    siteName: row.siteName,
                    consigneeName: row.consigneeName,
                    consigneePhone: row.consigneePhone,
                    beginTime: row.beginTime,
                    endTime: row.endTime,
                    openTime:row.openTime,
                    address:row.address,
                    longitude:row.longitude,
                    latitude:row.latitude,
                    status:row.status,
                    remark:row.remark,
                    provinceName:row.provinceName,
                    cityName:row.cityName,
                    areaName:row.areaName,
                    provinceCode:row.provinceCode,
                    cityCode:row.cityCode,
                    areaCode:row.areaCode,
                    maxNum:row.maxNum,
                }
                this.selectedOptions=[row.provinceCode,row.cityCode,row.areaCode];
                //this.selectedOptions.push(row.provinceCode,row.cityCode,row.areaCode);
                //this.selectedOptions.push(row.cityCode);
                //this.selectedOptions.push(row.areaCode);
                console.log(this.selectedOptions);
                this.dialogFormVisible = true;
            },

            //删除事件
            handleDelete(row){
                this.$confirm('删除批次, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteReunionSite({siteId:row.siteId}).then((res) => {
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.queryDataList();
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {});
            },
            handlePic(row){
                let routerL = '/' + this.$route.path.split('/')[1];
                this.$router.push({
                    path: routerL + '/picture/' + row.siteId,
                    query: {picType: '15', picName: row.siteName, picState: 'product'}
                })
            },
            //确定事件
            updateOrAddData(form) {

                if(form.siteName == "" ){
                    this.$message({
                        showClose: true,
                        message: '请填写站点名称',
                        type: 'error'
                    });
                    return false;
                }
                if(form.beginTime ==null || form.endTime ==null ){
                    this.$message({
                        showClose: true,
                        message: '开放起始结束日期不能为空',
                        type: 'error'
                    });
                    return false;
                }


                if(form.beginTime > form.endTime){
                    this.$message({
                        showClose: true,
                        message: '结束日期不能早于开始日期',
                        type: 'error'
                    });
                    return false;
                }
                this.form.beginTime=this.form.beginTime+' 00:00:00';
                this.form.endTime=this.form.endTime+' 00:00:00';
                const loading = this.$loading(this.GCONFIG.loadingParam);
                saveReunionSite(form).then((res) => {
                    loading.close();
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.queryDataList();
                        this.dialogFormVisible = false;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
        }
    }
</script>
<style scoped>
    .customer-id{
        text-decoration: underline;
    }
</style>


// WEBPACK FOOTER //
// src/views/reunion/ReunionSite.vue